import { productImageUrl, variantImageUrl } from "./mockIngestedProduct";
import type { GetCatalogAssetsResponse } from "@/types/catalogAssets";

/**
 * Sample catalog assets for tests, Storybook, local dev when {@link USE_MOCKS} is enabled,
 * and MSW handlers. Aligns with GET /{site_id}/assets/.
 */
export const mockCatalogAssetsResponse: GetCatalogAssetsResponse = {
  assets: [
    {
      id: 1,
      handle: "hero-main",
      url: productImageUrl,
      title: "Main product shot",
      type: "image",
      alt: "Kentest Trail Runner, side view",
      origin: "PDP_HERO",
      width: 1200,
      height: 1200,
      file_size: 245_760,
    },
    {
      id: 2,
      handle: "social-carousel-1",
      url: variantImageUrl,
      title: "Instagram carousel frame 1",
      type: "image",
      alt: "Trail runner on rocky path",
      origin: "SOCIAL",
      width: 1080,
      height: 1080,
      file_size: 198_400,
    },
    {
      id: 3,
      handle: "pdp-alt-detail",
      url: variantImageUrl,
      title: "Detail texture",
      type: "image",
      alt: "Mesh upper close-up",
      origin: "PDP_ALT",
      width: 800,
      height: 800,
      file_size: 112_000,
    },
    {
      id: 4,
      handle: "promo-loop",
      url: productImageUrl,
      title: "Spring launch promo",
      type: "video",
      alt: "Product in motion on trail",
      origin: "SOCIAL",
      width: 1920,
      height: 1080,
      file_size: 4_128_000,
    },
    {
      id: 5,
      handle: "untagged-asset",
      url: variantImageUrl,
      title: "Placeholder",
      type: "image",
      alt: "",
      origin: null,
      width: 400,
      height: 400,
      file_size: 24_000,
    },
  ],
  next: 100,
};

export function resolveMockCatalogAssets(): GetCatalogAssetsResponse {
  return mockCatalogAssetsResponse;
}
